import styled, { css } from 'styled-components';
import { Typography } from '../ui/Typography';
import { FlexibleDiv } from '../../styled/common';
import { TopSearchLineContainer } from '../NewSearch/styled';
import { Breakpoints } from '../../styled/constants';

export const SectionHeaderContainer = styled(TopSearchLineContainer)<{
  $hideOnDesk: boolean;
  $stackOnMobile: boolean;
}>`
  padding-top: 15px;
  padding-bottom: 15px;
  margin: 0 0 15px;
  box-sizing: border-box;

  ${({ $stackOnMobile, theme }) =>
    $stackOnMobile &&
    css`
      @media (max-width: ${Breakpoints.tablet}px) {
        flex-wrap: wrap;
        gap: 15px;

        & > * {
          flex: 1 1 100%;
        }
      }
    `}

  ${({ $hideOnDesk }) =>
    $hideOnDesk &&
    css`
      @media screen and (min-width: ${Breakpoints.tablet}px) {
        display: none;
      }
    `}
`;

export const StyledLink = styled(Typography)`
  line-height: 20px;
  color: ${({ theme: { colors } }) => colors.text.primary};
  padding-bottom: 1px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.text.primary};
  transition:
    color 0.3s ease,
    border-color 0.3s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.systemColors.blue};
    border-color: ${({ theme }) => theme.colors.systemColors.blue};
  }
`;

export const StyledLinkComponent = styled.a`
  text-decoration: none;
`;

export const Headline = styled(Typography)`
  margin: 0;
  line-height: 20px;
  font-size: 16px;
`;

export const PremiumTitle = styled.h1`
  font-size: 11px;
  font-weight: 400;
  color: #bcbcbc;
  margin: 0;
  text-align: right;
`;

export const HeaderRightBlock = styled(FlexibleDiv)`
  gap: 14px;
  align-items: center;
`;
